import { motion } from "framer-motion";

export const Nav = () => {
    const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    return (
        <motion.header
            initial={{ y: -60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-indigo-950/85 border-b border-indigo-400/25"
            data-testid="main-nav"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 h-24 sm:h-28 flex items-center justify-between">
                <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                    className="flex items-center gap-3 group" data-testid="nav-brand">
                    <div className="bg-white px-3 py-1.5 shadow-[0_4px_16px_rgba(0,0,0,0.35)]"><img src="/assets/logo.png" alt="Planet Valet logo" className="h-16 sm:h-20 w-auto" /></div>
                    <div className="bg-white px-3 py-1.5 shadow-[0_4px_16px_rgba(0,0,0,0.35)]"><img src="/assets/kisho-logo.png" alt="KISHO Ceramic Coatings logo" className="h-16 sm:h-20 w-auto" data-testid="nav-kisho-logo" /></div>
                </a>
                <a href="tel:+447481776151" className="hidden md:flex items-center gap-2.5 text-white hover:text-blue-300 transition-colors duration-300" data-testid="nav-phone-link">
                    <span className="text-lg font-bold tracking-wide">07481 776151</span>
                </a>
                <nav className="hidden md:flex items-center gap-10 text-lg tracking-[0.15em] uppercase font-bold text-white">
                    <button onClick={() => scrollTo("services")} className="border border-white/30 hover:border-blue-300 hover:text-blue-300 text-white text-sm tracking-[0.12em] uppercase font-semibold px-6 py-3 transition-colors duration-300" data-testid="nav-services-link">View Services</button>

                </nav>
                <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={() => scrollTo("book")}
                    className="bg-white hover:bg-blue-50 text-indigo-950 text-sm tracking-[0.12em] uppercase font-bold px-6 py-3 transition-colors duration-300"
                    data-testid="nav-book-now-button"
                >
                    Book a Valet
                </motion.button>
            </div>
        </motion.header>
    );
};
